import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChildren } from '@angular/core';
import { NavigationService } from 'src/app/navigation/navigation.service';
import { ModuleGroup } from 'src/shared/services/navigation-service-base';
import { ModuleInfo } from 'src/shared/models/module-info.model';
import { DashboardService } from '../../dashboard.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
    selector: 'cv-cxone-add-widget',
    templateUrl: './cxone-add-widget.component.html',
    styleUrls: ['./cxone-add-widget.component.scss'],
})

export class CXOneAddWidgetComponent implements OnInit, OnChanges {
    @Input() filterText = '';
    @Input() modules: ModuleInfo[];
    @Output() openPreview = new EventEmitter<void>();
    @Output() closePreview = new EventEmitter<void>();
    @Output() closeAddWidget = new EventEmitter<void>();
    @Output() ModuleGroup = new EventEmitter<any>();

    addingModule: boolean = false;
    moduleFilterText: string = '';
    isDragging: boolean = false;
    activeTab: number = 0;
    acdTab: string = 'acd-color';
    qmTab: string = 'qm-color';
    analyticsTab: string =  'analytics-color';
    metricsTab: string = 'metrics-color';
    coachingTab: string = 'coaching-color';
    pmTab: string = 'pm-color';
    iconPath: string = '../App_Themes/CXone/add-widget/';
    filteredGroups: ModuleGroup[] = [];
    private moduleGroups: ModuleGroup[] = [];
    placeholder: string = '';

    // for Preview
    currentModule: ModuleInfo;
    showPreview: boolean = false;
    timer;
    lag: number = 300;
    hoverIndex: string = "";
    continueShow: boolean = false;
    isAddModuleDropdown: boolean = true;

    constructor(
        public dashboardService: DashboardService,
        public navigationService: NavigationService,
        private cvLocalizationService: CVLocalizationService,
    ) {
        this.navigationService.groupedModules.subscribe(groups => {
            this.moduleGroups = groups;
            this.filterWidgetGroups();
            this.ModuleGroup.emit();
        });
    }

    @ViewChildren('filteredModules') filteredModules;

    async ngOnInit() {
        await this.cvLocalizationService.GetSection('CXOne_Dashboard');
        this.placeholder = this.cvLocalizationService.getCachedText('CXOne_Dashboard', 'Search_Widgets', 'Search widgets');
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.filterText) {
            this.filterWidgetGroups();
        }
    }

    public filterWidgetGroups() {
        this.filteredGroups = this.moduleGroups.filter(group => {
            if (!this.filterText)
                return true;
            const searchString = this.filterText.toLowerCase();
            return group.modules.some(module => module.LocalizedName.toLowerCase().includes(searchString));
        });
    }

    public widgetClicked(module: ModuleInfo) {
        if (this.navigationService.addingModule || this.navigationService.showOverlay)
            return;

        // pre-emptively show overlay
        if (module.options.settingsAvailable)
            this.navigationService.showOverlay = true;

        this.navigationService.addingModule = true;
        this.closePreview.emit();
        this.dashboardService.addModuleEvent.next(module);
        this.showPreview = false;
    }

    public onDragStart(event: DragEvent, module: ModuleInfo) {
        this.closePreview.emit();
        this.dashboardService.draggingModule = module;
    }

    public onDragEnd(event: DragEvent, module: ModuleInfo) {
        this.dashboardService.draggingModule = null;
    }

    public widgetGroupFilter(moduleGroup) {
        if (!this.moduleFilterText)
            return true;
        var searchString = this.moduleFilterText.toLowerCase();
        return moduleGroup.modules.some(function (module) { return module.LocalizedName.toLowerCase().includes(searchString); });
    };

    public hoverIn(module, event) {
        if (module == null) {
            this.hoverOut();
            return;
        }

        this.currentModule = module;
        var index = module.ModuleID
        this.showPreview = true;

        if (this.continueShow) {
            this.hoverIndex = index;
        } else {
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(function () {
                this.hoverIndex = index;
            }, this.lag);
        }
    }

    public hoverOut() {
        this.hoverIndex = null;
        clearTimeout(this.timer);
        this.timer = false;
        this.showPreview = false;
        this.continueShow = false;
    }

    public showWidgets() {
        // this variable must be truthy - set by adding the cv-display-modules attribute directive to an element
        if (!this.navigationService.displayModules) {
            return false;
        }

        // responsive dashboard must have a tab open
        if (!this.navigationService.activeDashboard) {
            return false;
        }

        // not a shared dashboard so we can show modules
        if (this.navigationService.activeDashboard.RelatedDashboardID <= 0) {
            return true;
        }

        // it is a shared dashboard but we have write access
        if (this.navigationService.activeDashboard.writeAccess) {
            return true;
        }
        return false;
    };

    public getWidgetIcon(module: ModuleInfo) {
        return module.DTO.IconPath;
    }

    public getWidgetGroupSvgPath(iconName) {
        if (!iconName)
            return null;

        const path = `${window['_BaseURI']}/App_Themes/CXone/icons/widgets/${iconName}.svg#${iconName}`;
        return path;
    }

    widgetGroupName(groups: string) {
        switch (groups){
            case 'performance' :
                return 'acd-color';
            case 'report':
                return 'qm-color';
            case 'tools':
                return 'analytics-color';
            case 'metrics':
                return 'metrics-color';
            case 'coaching':
                return 'coaching-color';
            case 'gamification':
                return 'pm-color';
        }
    }
}
